var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showANSILayers ||
    _vm.showCustomerLayers ||
    _vm.showDRTLayers ||
    _vm.showUSHRLayers ||
    _vm.analyticsVisible
    ? _c(
        "div",
        { staticClass: "layers-wrapper" },
        [
          _vm.oneToolToggle
            ? _c(
                "draggable",
                {
                  attrs: { "ghost-class": "ghost" },
                  on: {
                    end: function ($event) {
                      $event.preventDefault()
                      return _vm.onEnd()
                    },
                  },
                  model: {
                    value: _vm.layerButtons,
                    callback: function ($$v) {
                      _vm.layerButtons = $$v
                    },
                    expression: "layerButtons",
                  },
                },
                [
                  _c(
                    "transition-group",
                    { attrs: { type: "transition", name: "flip-list" } },
                    _vm._l(_vm.layerButtons, function (element, index) {
                      return _c(
                        "b-row",
                        {
                          key: element.name,
                          staticClass: "layer-row",
                          class: [
                            _vm.getLayerColClass(index, element),
                            _vm.highlightTopLayer(index),
                          ],
                          attrs: {
                            id: element.name,
                            "no-gutters": "",
                            disabled: _vm.checkLayerDisable(
                              element.name,
                              element.zoomControl,
                              element.minZoom
                            ),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("getLegend", element.name)
                            },
                          },
                        },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "layer-btn",
                              attrs: { cols: _vm.thresholdExists ? 8 : 8 },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleLayer(element, $event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    element.display_name
                                      ? element.display_name
                                      : element.name
                                  ) +
                                  "\n          "
                              ),
                              _vm.spinnerManager.includes(element.name)
                                ? _c("b-spinner", {
                                    staticClass: "spinner-custom-position",
                                    attrs: { variant: "primary", small: "" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "layer-arrow",
                              class: {
                                "layer-arrow--end": _vm.drtLayersToggle,
                              },
                              attrs: { cols: _vm.thresholdExists ? 4 : 4 },
                            },
                            [
                              _c("fa", {
                                staticClass: "cursor",
                                attrs: {
                                  title: "Move Layer To Top",
                                  icon: ["fas", "long-arrow-alt-up"],
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toTopOfList(
                                      element.display_name
                                        ? element.display_name
                                        : element.name
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              (_vm.drtLayersToggle || _vm.ansiLayersToggle) &&
                              _vm.globalIsUserAllowed("Filter_Modal")
                                ? _c("fa", {
                                    class: [
                                      _vm.filterClasses[index],
                                      {
                                        "disabled-icon":
                                          _vm.isLayerFilterDisabled,
                                      },
                                    ],
                                    attrs: {
                                      disabled: _vm.isLayerFilterDisabled,
                                      id: `icon${index}`,
                                      title: "Layer Filter",
                                      icon: ["fas", "filter"],
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit("getFilterModal", {
                                          layer: element.name,
                                          id: `icon${index}`,
                                        })
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.thresholdExists && element.positionThreshold
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "cursor circle",
                                      class: [
                                        {
                                          disabled: _vm.checkLayerDisable(
                                            element.name,
                                            element.zoomControl,
                                            element.minZoom
                                          ),
                                        },
                                        {
                                          activated:
                                            element.positionThreshold.some(
                                              (layerName) =>
                                                _vm.mmp_layersObj[layerName] &&
                                                _vm.checkLayer(
                                                  _vm.mmp_layersObj[layerName]
                                                    .layer
                                                )
                                            ),
                                        },
                                      ],
                                      attrs: { title: "Position Threshold" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleThreshold(
                                            element.positionThreshold,
                                            $event
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("P")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.thresholdExists && element.typeThreshold
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "cursor circle",
                                      class: [
                                        {
                                          disabled: _vm.checkLayerDisable(
                                            element.name,
                                            element.zoomControl,
                                            element.minZoom
                                          ),
                                        },
                                        {
                                          activated: element.typeThreshold.some(
                                            (layerName) =>
                                              _vm.mmp_layersObj[layerName] &&
                                              _vm.checkLayer(
                                                _vm.mmp_layersObj[layerName]
                                                  .layer
                                              )
                                          ),
                                        },
                                      ],
                                      attrs: { title: "Type Change Threshold" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleThreshold(
                                            element.typeThreshold,
                                            $event
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("T")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }